export default "__VITE_ASSET__WUIYp_Ct__"